import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { SYS_ADMIN } from 'config/permissions/roles';
import adminTrendComponent from './admin-trend.component';
import adminTrendService from './admin-trend.service';

export default
  angular.module('components.reports.adminTrend', [
    uiRouter
  ])
    .component('administrationTrend', adminTrendComponent)
    .service('AdminTrendService', adminTrendService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('administrationTrend', {
          parent: 'reports',
          url: '/administrations-trend',
          component: 'administrationTrend',
          data: {
            permissions: {
              only: [SYS_ADMIN],
              redirectTo: 'dashboard'
            }
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/reports/admin-trend/admin-trend.module.js